<template>
  <div :class="wrapperClass">
    <img
      v-if="clientLogo"
      :src="clientLogo"
      class="client-logo"
    >
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { storeToRefs } from 'pinia'

  import { useAccountsStore } from '@/stores/accounts'
  import { useTreeStore } from '@/stores/tree'

  defineOptions({ name: 'ClientLogo' })

  const props = defineProps({
    additionalClass: {
      required: false,
      type: String,
      default: ''
    }
  })

  const accountsStore = useAccountsStore()
  const { user } = storeToRefs(accountsStore)

  const wrapperClass = computed(() => {
    return ['client-logo-container', props.additionalClass].join(' ')
  })

  const clientLogo = computed(() => {
    const treeStore = useTreeStore()
    const client = treeStore.clients[user.value.active_client]
    if (!client) return ''
    return client.settings?.tmc_logo || client.logo_key || ''
  })
</script>

<style scoped>
  .client-logo-container {
    padding: 10px;
    text-align: center;
  }

  .client-logo {
    max-width: 100%;
    max-height: 80px;
    width: auto;
    height: auto;
    object-fit: contain;
  }
</style>
